
<script setup>
import { Hints, Heading, MultiSelect, Alert, SectionHead } from '@components'

// Settings
import DarkModeStore from '@o/store'
const { options } = DarkModeStore()

// Contents
import useContents from '@stores/contents'
const $contents = useContents()

const isWCInstalled = wp_dark_mode_admin_json.wc.is_installed
const isWCActive = wp_dark_mode_admin_json.wc.is_active

</script>

<template>
    <Row transparent gap="6">
        <SectionHead  class="text-lg"> {{__('Exclude WooCommerce', 'wp-dark-mode')}} <template #description>
             {{__('Exclude dark mode on WooCommerce products and categories', 'wp-dark-mode')}}
            </template>
        </SectionHead>
        <Alert color="orange" v-if="!isWCInstalled || !isWCActive"> {{ isWCInstalled ? __('WooCommerce is not active', 'wp-dark-mode') :
            __('WooCommerce is not installed', 'wp-dark-mode') }}.  {{ isWCInstalled ? __('Please active WooCommerce to use this feature.', 'wp-dark-mode') : __('Please install WooCommerce to use this feature', 'wp-dark-mode') }}  </Alert>
        <Row class="flex-col sm:flex-row" space :disabled="!isWCInstalled || !isWCActive">
           
            <Heading class="whitespace-nowrap">
                <Row inline center>
                    <Row locked :ProBadge="false"  class="whitespace-nowrap">{{__('Exclude WC Products', 'wp-dark-mode')}}</Row> <ProBadge />
                </Row>
            </Heading>
            <Row class="w-full" locked>
                <MultiSelect :items="$contents.products" v-model="options.excludes_wc_products"
                    placeholder="Enter your selected WooCommerce products" :disabled="options.excludes_wc_products_all" />
                <Hints>{{__('Add products to exclude the dark mode from the WooCommerce categories.', 'wp-dark-mode')}}</Hints>
                <Row inline class="pt-[10px] text-sm"><span class="font-semibold">{{__('Exclude All', 'wp-dark-mode')}}</span>
                    <Toggle v-model="options.excludes_wc_products_all">{{__('Except:', 'wp-dark-mode')}}</Toggle>
                </Row>
                <MultiSelect :items="$contents.products" v-model="options.excludes_wc_products_except"
                    placeholder="Enter WooCommerce products" :disabled="!options.excludes_wc_products_all" />
                <Hints>{{__('Dark Mode will only work on the selected WooCommerce products.', 'wp-dark-mode')}}</Hints>
            </Row>
        </Row>
        <Row class="flex-col sm:flex-row" space :disabled="!isWCInstalled || !isWCActive">
       
            <Heading class="whitespace-nowrap">
                <Row inline center>
                    <Row locked :ProBadge="false"  class="whitespace-nowrap">{{__('Exclude WC Categories', 'wp-dark-mode')}}</Row> <ProBadge />
                </Row>
            </Heading>
            <Row class="w-full" locked>
                <MultiSelect :items="$contents.productCategories" v-model="options.excludes_wc_categories"
                    placeholder="Enter your selected WooCommerce categories"
                    :disabled="options.excludes_wc_categories_all" />
                <Hints>{{__('Add categories to exclude the dark mode from the WooCommerce categories.', 'wp-dark-mode')}}</Hints>
                <Row inline class="pt-[10px] text-sm"><span class="font-semibold">{{__('Exclude All', 'wp-dark-mode')}}</span>
                    <Toggle v-model="options.excludes_wc_categories_all">{{__('Except:', 'wp-dark-mode')}}</Toggle>
                </Row>
                <MultiSelect :items="$contents.productCategories" v-model="options.excludes_wc_categories_except"
                    placeholder="Enter WooCommerce categories" :disabled="!options.excludes_wc_categories_all" />
                <Hints>{{__('Dark Mode will only work on the selected WooCommerce categories.', 'wp-dark-mode')}}</Hints>
            </Row>
        </Row>
    </Row>
</template>
